import React from "react";
import RouteBuilder from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const PlanAnualWidget = lazyWithRetry(
  () => import("./ui/PlanAnualWidget"),
  "PlanAnualWidget",
);

/**
 * Rutas del plan anual
 */
const planAnualRoutes = [
  RouteBuilder.protected(
    "/admin/plan-anual",
    () => <PlanAnualWidget modo="admin" />,
    [1, 5],
  ),
  RouteBuilder.protected(
    "/supervisor/plan-anual",
    () => <PlanAnualWidget autoDetectRole={true} />,
    [3, 4, 5],
  ),
  RouteBuilder.protected(
    "/inspector/plan-anual",
    () => <PlanAnualWidget autoDetectRole={true} />,
    [2, 5],
  ),
  RouteBuilder.protected(
    "/rh/plan-anual",
    () => <PlanAnualWidget autoDetectRole={true} />,
    [7, 5],
  ),
];

export default planAnualRoutes;
